import React, { useRef } from 'react';
import cx from 'classnames';
import { PlayModal } from '../../modals/PlayModal/index.js';
import styles from './index.module.scss.js';

const GameBanner = ({
  onBannerClick = () => {
  },
  id,
  playModalProps,
  mainBackgroundColor = "transparent",
  preview = {
    alt: "",
    url: "#"
  },
  blockPageScroll = false,
  animation = {
    "data-aos": "fade-up",
    "data-aos-delay": "200",
    "data-aos-delay-step": 0,
    "data-aos-duration": "1000"
  },
  showPreview = true,
  children,
  className,
  style
}) => {
  const ref = useRef(null);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ref.current && playModalProps && /* @__PURE__ */ React.createElement(
    PlayModal,
    {
      ...playModalProps,
      parentSelector: ref.current ? () => ref.current : void 0,
      blockPageScroll
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className),
      style: {
        ...style,
        background: mainBackgroundColor
      },
      onClick: onBannerClick,
      ref,
      id,
      tabIndex: 0,
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          onBannerClick();
        }
      },
      role: "button",
      ...animation
    },
    showPreview && /* @__PURE__ */ React.createElement("img", { src: preview.url, alt: preview.alt }),
    /* @__PURE__ */ React.createElement("div", { className: styles.content }, children)
  ));
};
GameBanner.displayName = "GameBanner";

export { GameBanner };
//# sourceMappingURL=index.js.map
